import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, formatError } from "@/lib/api";
import { scale } from "@/lib/nutri";

export const PortionForm = ({ food, meal, date, source = "db", onDone, onBack }) => {
  const [grams, setGrams] = useState(100);
  const [saving, setSaving] = useState(false);
  const m = scale(food, grams);

  const add = async () => {
    setSaving(true);
    try {
      await api.post("/nutri/entries", { date, meal, name: food.name, grams: Number(grams), source, ...m });
      toast.success(`${food.name} aggiunto`);
      onDone();
    } catch (e) {
      toast.error(formatError(e));
      setSaving(false);
    }
  };

  return (
    <div data-testid="portion-form" className="space-y-4 pt-4">
      <p className="font-display text-2xl font-800 uppercase">{food.name}</p>
      <label className="block space-y-1.5">
        <span className="font-mono text-[11px] uppercase tracking-widest text-[#a3b1aa]">Quantità (g)</span>
        <Input data-testid="portion-grams-input" type="number" min="1" value={grams} onChange={(e) => setGrams(e.target.value)} className="h-12 text-lg" />
      </label>
      <div className="grid grid-cols-4 gap-2 text-center font-mono text-xs" data-testid="portion-preview">
        {[["kcal", m.kcal], ["P", m.protein], ["C", m.carbs], ["G", m.fat]].map(([l, v]) => (
          <div key={l} className="border border-white/10 py-2"><p className="text-[#a3b1aa]">{l}</p><p className="text-base">{v}</p></div>
        ))}
      </div>
      <div className="flex gap-2">
        <button data-testid="portion-back-btn" onClick={onBack} className="border border-white/15 px-4 font-mono text-xs uppercase">Indietro</button>
        <button data-testid="portion-add-btn" disabled={saving || !(Number(grams) > 0)} onClick={add}
          className="flex-1 bg-[#98bfa2] py-3 font-display text-lg font-800 uppercase text-[#050807] hover:bg-[#c4dcca] disabled:opacity-50">
          Aggiungi
        </button>
      </div>
    </div>
  );
};
